import * as React from 'react';
import * as Styled from './theme-mode-switcher.styles';
export const DarkMode = ({ children, ...props }) => (React.createElement(Styled.ThemeModeSwitcher, { className: "is-dark-theme", ...props }, children));
DarkMode.displayName = 'DarkMode';
export const LightMode = ({ children, ...props }) => (React.createElement(Styled.ThemeModeSwitcher, { className: "is-light-theme", ...props }, children));
LightMode.displayName = 'LightMode';
//# sourceMappingURL=theme-mode-switcher.js.map